import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CustomerServiceFeeComponent } from './customer-service-fee.component';
import { ServiceFeeTypeComponent } from './service-fee-type.component';
import { OrganisationSelectListComponent } from '../organisation-list/organisation-select-list.component';

const routes: Routes = [
  {
    path: '',
    component: CustomerServiceFeeComponent,
    data: { title: 'Service Fee' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ServiceFeeRoutingModule {}

@NgModule({
  imports: [
    ServiceFeeRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [CustomerServiceFeeComponent, ServiceFeeTypeComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [CustomerServiceFeeComponent, ServiceFeeTypeComponent],
})
export class ServiceFeeModule {}
